import { useMonitor } from '../use-monitor';

export function useMonitorCreateIssueFormIssueSubtypesLoad() {
  return useMonitor('create-issue-form-issue-subtypes-load');
}
